import { motion, useMotionValue, useTransform, animate } from "framer-motion";
import { useEffect, useState } from "react";

const ScoreGauge = ({ score, size = 200 }) => {
  const strokeWidth = 12;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const progress = (score / 100) * circumference;

  const getColor = (s) => {
    if (s < 50) return "#FF3B30";
    if (s < 80) return "#FFCC00";
    return "#34C759";
  };

  const getLabel = (s) => {
    if (s < 50) return "Needs Work";
    if (s < 80) return "Fair";
    return "Good";
  };

  const color = getColor(score);

  const [displayScore, setDisplayScore] = useState(0);
  useEffect(() => {
    const controls = animate(0, score, {
      duration: 1.5,
      ease: "easeOut",
      onUpdate: (v) => setDisplayScore(Math.round(v)),
    });
    return controls.stop;
  }, [score]);

  return (
    <div className="relative inline-flex items-center justify-center" data-testid="score-gauge">
      {/* Glow backdrop */}
      <div
        className="absolute rounded-full"
        style={{
          width: size + 40,
          height: size + 40,
          background: `radial-gradient(circle, ${color}15 0%, transparent 70%)`,
          filter: `blur(30px)`,
        }}
      />
      <svg width={size} height={size} className="relative z-10 -rotate-90">
        {/* Background track */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="rgba(255,255,255,0.06)"
          strokeWidth={strokeWidth}
        />
        {/* Score arc */}
        <motion.circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          initial={{ strokeDashoffset: circumference }}
          animate={{ strokeDashoffset: circumference - progress }}
          transition={{ duration: 1.5, ease: "easeOut", delay: 0.3 }}
          style={{
            filter: `drop-shadow(0 0 8px ${color}80)`,
          }}
        />
      </svg>
      {/* Center text */}
      <div className="absolute z-10 flex flex-col items-center justify-center">
        <span
          className="text-5xl sm:text-6xl font-black font-['Outfit'] leading-none"
          style={{ color }}
        >
          {displayScore}
        </span>
        <span
          className="text-xs font-bold tracking-[0.2em] uppercase mt-1"
          style={{ color: "rgba(255,255,255,0.5)" }}
        >
          {getLabel(score)}
        </span>
      </div>
    </div>
  );
};

export default ScoreGauge;
